<script>
import mixins from "../../mixins";

export default {
  name: "InfoChart",
  mixins: [mixins],
  props: {
    name: String,
    amount: Number,
    total: Number,
    pricesList: Array,
    withOtherPrices: { type: Boolean, default: false },
  },
  data() {
    return {
      series: [0],
      chartOptions: {
        colors: ["#41807a"],
        stroke: {
          lineCap: "round",
        },
        chart: {
          height: "100%",
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "40%",
            },
            track: {
              background: "#d4d4d7",
            },
            dataLabels: {
              show: false,
            },
          },
        },
      },
      isActive: false,
    };
  },
  methods: {
    updateChart() {
      const newPercentage = this.getPercentage(this.amount, this.total);
      this.series = [newPercentage];
    },

    getPercentage(amount, total) {
      const percentage = 100;
      return (amount * percentage) / total;
    },
    addCommas(nStr) {
      nStr += "";
      let x = nStr.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1] : "";
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    setPriceArray(infoType) {
      const arrayList = [];
      this.pricesList?.forEach((key) => {
        if (key.info == infoType && key != undefined) {
          arrayList.push(key.totalPrice);
        }
      });
      return arrayList;
    },
  },

  mounted() {
    this.updateChart();
  },

  computed: {
    sumTurkishLira() {
      const resultArray = this.setPriceArray("₺");
      if (resultArray.length > 0) {
        return resultArray.reduce((a, c) => {
          return a + c;
        });
      } else {
        return "";
      }
    },
    sumDollar() {
      const resultArray = this.setPriceArray("$");
      if (resultArray.length > 0) {
        return resultArray.reduce((a, c) => {
          return a + c;
        });
      } else {
        return "";
      }
    },
    sumEuro() {
      const resultArray = this.setPriceArray("€");
      if (resultArray.length > 0) {
        return resultArray.reduce((a, c) => {
          return a + c;
        });
      } else {
        return "";
      }
    },
  },
  watch: {
    pricesList(value) {
      this.isActive = value.length > 0;
    },
  },
};
</script>

<template>
  <div class="infos-container">
    <div class="infos-container-info">
      <p>{{ name }}</p>
      <h2 v-if="!withOtherPrices">
        <div class="inline-block" v-if="amount > 1">
          {{ formatPriceNoDecimal(amount) }} TL
        </div>
        <div class="inline-block" v-else>{{ amount }} TL</div>
        <span>/ {{ formatPriceNoDecimal(total) }} TL</span>
      </h2>
      <h2 v-else-if="withOtherPrices">
        <div v-if="!isActive">0 TL</div>
        <div class="inline-block" v-else>
          <div class="inline-block" v-if="sumTurkishLira">
            {{ sumTurkishLira }} TL
          </div>
          <div v-else>0 TL</div>
          <div class="inline-block" v-if="sumDollar">+ {{ sumDollar }} USD</div>
          <div class="inline-block" v-if="sumEuro">+ {{ sumEuro }} EUR</div>
        </div>
      </h2>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.infos-container {
  display: flex;
  align-items: center;
  border: 1px solid #ecedef;
  justify-content: center;
  padding: 10px 20px;
  flex-direction: column;
  min-width: 226px;
  @media (max-width: 768px) {
    min-width: 100%;
    padding: 11px 0px;
  }
  .inline-block {
    display: inline-block;
  }
  &:last-child {
    flex: 1;
  }
  &-chart {
    width: 45px;
    margin-left: -20px;
    margin-right: 15px;
  }

  &-circle {
    width: 45px;
    margin-left: -30px;
    margin-right: 9px;

    svg {
      width: 55px;
      height: 55px;
    }
  }

  &-info {
    p {
      font-size: 14px;
      margin-bottom: 5px;

      @media (max-width: 768px) {
        font-size: 11px;
        margin-bottom: 0px;
      }
    }

    h2 {
      color: var(--color-primary-default);
      font-weight: bold;
      font-size: 16px;
      @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 0px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: var(--grayscale-50);
      }
      .inline-block {
        display: inline-block;
        padding-right: 5px;

        &:last-child {
          padding-right: 0px;
        }
      }
    }
  }
}
</style>
